<template>
  <span class="status">
    <span
      v-if="bulletPosition === 'left'"
      class="status__label status__label--left"
      :title="label || getCompanyStatus(statusMapead)"
    >
      {{ label || getCompanyStatus(statusMapead) }}
    </span>

    <span class="status__bullet" :class="`status__bullet--${statusMapead.toLowerCase()}`" />

    <span
      v-if="bulletPosition === 'right'"
      class="status__label status__label--right"
      :title="label || getCompanyStatus(statusMapead)"
    >
      {{ label || getCompanyStatus(statusMapead) }}
    </span>
  </span>
</template>

<script>
import { objectToArray } from 'utils/functions'

export default {
  name: 'StatusBullet',
  props: {
    status: {
      type: String
    },
    label: {
      type: String
    },
    bulletPosition: {
      type: String,
      default: 'right'
    }
  },
  computed: {
    statusMapead () {
      const status = typeof this.status === 'string' ? this.status.toLowerCase() : null
      return status === 'ativa' ? 'enabled' : this.status
    }
  },
  methods: {
    getCompanyStatus (val) {
      if (!val) return '-'

      const statusList = objectToArray(this.$t('Views.CompanyPage.anonymousCompanies.filters.statusList'))
      const getStatusText = (status) => {
        const statusTarget = statusList.find(s => s.value === status)
        return statusTarget ? statusTarget.text : null
      }

      const status = {
        enabled: this.$t('Views.CompanyDetailsPage.enabled'),
        Ativa: this.$t('Views.CompanyDetailsPage.enabled'),
        ativa: this.$t('Views.CompanyDetailsPage.enabled'),
        fraudSuspect: this.$t('Views.CompanyDetailsPage.fraudSuspect'),
        offboarding: this.$t('Views.CompanyDetailsPage.offboarding'),
        disabled: this.$t('Views.CompanyDetailsPage.disable'),
        disable: this.$t('Views.CompanyDetailsPage.disable'),
        indebt: this.$t('Views.CompanyDetailsPage.indebt'),
        pendingEmail: this.$t('Views.CompanyDetailsPage.pendingEmail'),
        empresaemsememail: this.$t('Views.CompanyDetailsPage.empresaemsememail'),
        onboarding: this.$t('Views.CompanyDetailsPage.onboarding'),
        REQUESTED: getStatusText('REQUESTED'),
        CONFIRMED: getStatusText('CONFIRMED'),
        DELETED: getStatusText('DELETED'),
        SUCCESS: getStatusText('SUCCESS'),
        PAID_OUT: this.$t('Components.FinancialInvoicesHistory.paidOut'),
        AUTHORISED: this.$t('Components.FinancialInvoicesHistory.authorised'),
        INVOICE_SENT: this.$t('Components.FinancialInvoicesHistory.invoiceSent'),
        REFUSED: this.$t('Components.FinancialInvoicesHistory.refused'),
        LATE: this.$t('Components.FinancialInvoicesHistory.late'),
        EXTEND: this.$t('Components.FinancialInvoicesHistory.maturityExtended'),
        AUTHORISATION_SENT: this.$t('Components.FinancialInvoicesHistory.authorisationSent'),
        CAPTURED_SENT: this.$t('Components.FinancialInvoicesHistory.capturedSent'),
        CAPTURED: this.$t('Components.FinancialInvoicesHistory.captured'),
        REPROCESSING_PAYMENT: this.$t('Components.FinancialInvoicesHistory.reprocessingPayment')
      }

      return status[val] || val
    }
  }
}
</script>

<style lang="scss" scoped>
.status {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  padding-left: 16px;
  position: relative;
}

.status__bullet {
  background-color: #eee;
  border-radius: 50%;
  height: 16px;
  left: 0;
  position: absolute;
  top: 2px;
  width: 16px;
}

.status__bullet--enabled,
.status__bullet--onboarding,
.status__bullet--success,
.status__bullet--paid_out,
.status__bullet--captured {
  background-image: linear-gradient(135deg, #b4ec51, #2dcc70);
}

.status__bullet--success-warning,
.status__bullet--invoice_sent,
.status__bullet--authorised {
  background-image: linear-gradient(135deg, #b4ec51, #2dcc70);
  position: absolute;

  &:after {
    content: '';
    background-image: linear-gradient(135deg, #ffdd00, #ffb400);
    border-radius: 50%;
    height: 8.5px;
    left: 4px;
    position: absolute;
    top: 4px;
    width: 8.5px;
  }
}

.status__bullet--disable,
.status__bullet--disabled,
.status__bullet--offboarding,
.status__bullet--deleted,
.status__bullet--error {
  background-image: linear-gradient(135deg, #d8080f, #aa0419);
}

.status__bullet--warning,
.status__bullet--fraudsuspect,
.status__bullet--fraudSuspect,
.status__bullet--pendingEmail,
.status__bullet--empresaemsememail,
.status__bullet--indebt,
.status__bullet--confirmed,
.status__bullet--refused,
.status__bullet--late,
.status__bullet--warning,
.status__bullet--authorisation_sent,
.status__bullet--captured_sent,
.status__bullet--reprocessing_payment {
  background-image: linear-gradient(135deg, #ffdd00, #ffb400);
}

.status__bullet--warning-success,
.status__bullet--extend {
  background-image: linear-gradient(135deg, #ffdd00, #ffb400);
  position: absolute;

  &:after {
    content: '';
    background-image: linear-gradient(135deg, #b4ec51, #2dcc70);
    border-radius: 50%;
    height: 8.5px;
    left: 4px;
    position: absolute;
    top: 4px;
    width: 8.5px;
  }
}

.status__bullet--requested {
  background-image: linear-gradient(135deg, #eee, #d1d1d1);
}

.status__label {
  font-size: 100%;
  font-family: 'Work Sans', sans-serif;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.status__label--left {
    margin-right: 8px;
  }

  &.status__label--right {
    margin-left: 8px;
  }
}
</style>
